var map = {
	"./banner-2.jpg": 2573,
	"./banner-designer.png": 5893,
	"./banner.jpg": 4598,
	"./banner_231004.png": 465,
	"./banner_cheonan2025.png": 665,
	"./banner_comicworld2025.png": 9675,
	"./banner_earlyaccess_pc.png": 8327,
	"./banner_game_download.png": 4027,
	"./banner_gstar2024.png": 7234,
	"./banner_horse_update.png": 5530,
	"./banner_mr1_update.png": 2605,
	"./banner_promotion_2505.png": 3597,
	"./banner_promotion_2507.png": 3466,
	"./banner_snake_update.png": 1476,
	"./banner_stoveindie_demo.png": 3027,
	"./banner_stovelaunch.png": 8912,
	"./christmas_update_2023.jpeg": 3356,
	"./funding_skin_banner.png": 8314,
	"./palace_update_banner.png": 7865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4683;